const BYTES_PER_KILOBYTE = 1024;
const BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * BYTES_PER_KILOBYTE;
const FILE_SIZE_UNITS = ['Bytes', 'KB', 'MB', 'GB'] as const;

export const DEFAULT_MAX_FILE_SIZE_MB = 10;
export const DEFAULT_MAX_FILE_SIZE_BYTES =
  DEFAULT_MAX_FILE_SIZE_MB * BYTES_PER_MEGABYTE;

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KILOBYTE));

  return (
    parseFloat((bytes / Math.pow(BYTES_PER_KILOBYTE, sizeIndex)).toFixed(2)) +
    ' ' +
    FILE_SIZE_UNITS[sizeIndex]
  );
};
